import { useScreen } from '@/hooks/useScreen';
import { postUserAvatar } from 'apis/profile.api';
import { useContext, useState } from 'react';
import { DEFAULT_AVT_IMG } from '../../../../../../constant/imgImport';
import Avatar from '../../../../../image/Avatar';
import AvatarCropper from '../../../../../image/AvatarCropper';
import { EnterpriseProfileDataContext } from '../context/EnterpriseProfileDataContext';

const EnterpriseAvatar = ({
  canEdit,
  avatarUrl,
}: {
  canEdit: boolean;
  avatarUrl: string | null;
}) => {
  const { isDesktop } = useScreen();
  const [openModal, setOpenModal] = useState(false);
  const { setData } = useContext(EnterpriseProfileDataContext);

  const onSuccess = (imgValue: string) => {
    setData((prev) => {
      const newState = { ...prev };
      if (!newState.profiles) return prev;

      newState.profiles.avatar = imgValue;

      return newState as any;
    });
  };

  return (
    <>
      <Avatar
        editIconPosition="left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2 lg:translate-y-1/3"
        canEdit={canEdit}
        positionClass="left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full shadow-[0px_10px_40px_rgba(0,0,0,0.25)]" //because position class is use as class in Avatar, so i put shadow css in this property too
        handleClickEdit={() => setOpenModal(true)}
        imgProps={{
          src: avatarUrl || DEFAULT_AVT_IMG,
          className: `rounded-full overflow-hidden w-[200px] aspect-square ${
            !isDesktop && 'w-[80px]'
          }`,
        }}
      />
      <AvatarCropper
        open={openModal}
        toggle={() => setOpenModal(false)}
        onSuccess={onSuccess}
        asyncFunc={(avatar: File) => postUserAvatar({ avatar })}
      />
    </>
  );
};

export default EnterpriseAvatar;
